/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiComponentBlockCategoryFromJSON, ApiComponentBlockCategoryToJSON, } from './ApiComponentBlockCategory';
import { ApiComponentTypeFromJSON, ApiComponentTypeToJSON, } from './ApiComponentType';
import { ApiComponentUISourceFromJSON, ApiComponentUISourceToJSON, } from './ApiComponentUISource';
import { ApiLandingPathFromJSON, ApiLandingPathToJSON, } from './ApiLandingPath';
import { ApiPersonalisationFromJSON, ApiPersonalisationToJSON, } from './ApiPersonalisation';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiComponentFromJSON(json) {
    return ApiComponentFromJSONTyped(json, false);
}
export function ApiComponentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aiCss': !exists(json, 'aiCss') ? undefined : json['aiCss'],
        'aiHtml': !exists(json, 'aiHtml') ? undefined : json['aiHtml'],
        'aiJs': !exists(json, 'aiJs') ? undefined : json['aiJs'],
        'category': !exists(json, 'category') ? undefined : ApiComponentBlockCategoryFromJSON(json['category']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'css': !exists(json, 'css') ? undefined : json['css'],
        'cssMin': !exists(json, 'cssMin') ? undefined : json['cssMin'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'favicon': !exists(json, 'favicon') ? undefined : json['favicon'],
        'grapeJs': !exists(json, 'grapeJs') ? undefined : json['grapeJs'],
        'head': !exists(json, 'head') ? undefined : json['head'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'htmlMin': !exists(json, 'htmlMin') ? undefined : json['htmlMin'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'js': !exists(json, 'js') ? undefined : json['js'],
        'jsMin': !exists(json, 'jsMin') ? undefined : json['jsMin'],
        'landingPaths': !exists(json, 'landingPaths') ? undefined : (json['landingPaths'].map(ApiLandingPathFromJSON)),
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiUserFromJSON(json['lastUser']),
        'lastUserId': !exists(json, 'lastUserId') ? undefined : json['lastUserId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : ApiUserFromJSON(json['owner']),
        'ownerId': !exists(json, 'ownerId') ? undefined : json['ownerId'],
        'pending': !exists(json, 'pending') ? undefined : (new Date(json['pending'])),
        'personalisations': !exists(json, 'personalisations') ? undefined : (json['personalisations'].map(ApiPersonalisationFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'promptId': !exists(json, 'promptId') ? undefined : json['promptId'],
        'screenshotTaken': !exists(json, 'screenshotTaken') ? undefined : json['screenshotTaken'],
        'seoDescrition': !exists(json, 'seoDescrition') ? undefined : json['seoDescrition'],
        'seoTitle': !exists(json, 'seoTitle') ? undefined : json['seoTitle'],
        'theme': !exists(json, 'theme') ? undefined : json['theme'],
        'type': !exists(json, 'type') ? undefined : ApiComponentTypeFromJSON(json['type']),
        'uiSource': !exists(json, 'uiSource') ? undefined : ApiComponentUISourceFromJSON(json['uiSource']),
    };
}
export function ApiComponentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aiCss': value.aiCss,
        'aiHtml': value.aiHtml,
        'aiJs': value.aiJs,
        'category': ApiComponentBlockCategoryToJSON(value.category),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'css': value.css,
        'cssMin': value.cssMin,
        'description': value.description,
        'favicon': value.favicon,
        'grapeJs': value.grapeJs,
        'head': value.head,
        'html': value.html,
        'htmlMin': value.htmlMin,
        'id': value.id,
        'js': value.js,
        'jsMin': value.jsMin,
        'landingPaths': value.landingPaths === undefined ? undefined : (value.landingPaths.map(ApiLandingPathToJSON)),
        'lastUser': ApiUserToJSON(value.lastUser),
        'lastUserId': value.lastUserId,
        'name': value.name,
        'owner': ApiUserToJSON(value.owner),
        'ownerId': value.ownerId,
        'pending': value.pending === undefined ? undefined : (value.pending.toISOString()),
        'personalisations': value.personalisations === undefined ? undefined : (value.personalisations.map(ApiPersonalisationToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'promptId': value.promptId,
        'screenshotTaken': value.screenshotTaken,
        'seoDescrition': value.seoDescrition,
        'seoTitle': value.seoTitle,
        'theme': value.theme,
        'type': ApiComponentTypeToJSON(value.type),
        'uiSource': ApiComponentUISourceToJSON(value.uiSource),
    };
}
